var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXClose = function SvgXClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71 1.917a.567.567 0 0 0-.796 0 .565.565 0 0 0 0 .797l4.29 4.289-4.29 4.289a.562.562 0 0 0 .795.795l4.289-4.29 4.291 4.292a.562.562 0 0 0 .795-.795l-4.29-4.289 4.292-4.291a.562.562 0 0 0-.795-.795L7.002 6.21z"
  })));
};
export default SvgXClose;